<div class="profile-preview">
  <app-card>
    <div class="preview-content">
      <!-- Show profile data when loaded -->
      <div class="preview-body" *ngIf="!isLoading">
        <div class="preview-section">
          <div class="essentials-layout">
            <div class="essentials-layout__aside">
              <app-user-avatar
                class="essentials-layout__avatar"
                size="lg"
                [editable]="true"
                [loading]="avatarLoading"
                [photo]="avatarPhoto"
                [firstName]="avatarFirstName"
                [lastName]="avatarLastName"
                [identifier]="avatarIdentifier"
                (edit)="avatarEdit.emit()"
                (remove)="avatarRemove.emit()">
              </app-user-avatar>
            </div>
            <div class="essentials-layout__main">
              <h3 class="section-title">{{ 'profile.personal.essentials' | transloco }}</h3>
              <div class="section-content">
            <div class="preview-field">
              <span class="field-label">{{ 'profile.personal.titleField' | transloco }}</span>
              <span class="field-value">{{ userProfile?.['title'] || '-' }}</span>
            </div>
            <div class="preview-field">
              <span class="field-label">{{ 'profile.personal.firstName' | transloco }}</span>
              <span class="field-value">{{ userProfile?.['firstName'] || '-' }}</span>
            </div>
            <div class="preview-field">
              <span class="field-label">{{ 'profile.personal.lastName' | transloco }}</span>
              <span class="field-value">{{ userProfile?.['lastName'] || '-' }}</span>
            </div>
            <div class="preview-field">
              <span class="field-label">{{ 'profile.personal.titleAfterName' | transloco }}</span>
              <span class="field-value">{{ userProfile?.['titleAfterName'] || '-' }}</span>
            </div>

            <div class="preview-field">
              <span class="field-label">{{ 'profile.personal.email' | transloco }}</span>
              <span class="field-value">{{ userProfile?.email || userEmail || '-' }}</span>
            </div>
            <div class="preview-field">
              <span class="field-label">{{ 'profile.personal.phone' | transloco }}</span>
              <span class="field-value">{{ (userProfile?.telephone | phoneFormat) || '-' }}</span>
            </div>

            <div class="preview-field">
              <span class="field-label">{{ 'profile.personal.gender' | transloco }}</span>
              <span class="field-value">{{ getGenderLabel(userProfile?.gender) | transloco }}</span>
            </div>
            <div class="preview-field">
              <span class="field-label">{{ 'profile.personal.dateOfBirth' | transloco }}</span>
              <span class="field-value">{{ formatDate(userProfile?.['birthDate']) }}</span>
            </div>
          </div>
          </div>
          </div>
        </div>

        <div class="separator"></div>

        <div class="preview-section">
          <h3 class="section-title">{{ 'profile.personal.addressTitle' | transloco }}</h3>
          <div class="section-content">
            <div class="preview-field">
              <span class="field-label">{{ 'profile.personal.streetName' | transloco }}</span>
              <span class="field-value">{{ userProfile?.address?.streetName || '-' }}</span>
            </div>
            <div class="preview-field">
              <span class="field-label">{{ 'profile.personal.streetNumber' | transloco }}</span>
              <span class="field-value">{{ userProfile?.address?.streetNumber || '-' }}</span>
            </div>

            <div class="preview-field">
              <span class="field-label">{{ 'profile.personal.city' | transloco }}</span>
              <span class="field-value">{{ userProfile?.address?.city || '-' }}</span>
            </div>
            <div class="preview-field">
              <span class="field-label">{{ 'profile.personal.zipCode' | transloco }}</span>
              <span class="field-value">{{ userProfile?.address?.postalCode || '-' }}</span>
            </div>

            <div class="preview-field">
              <span class="field-label">{{ 'profile.personal.country' | transloco }}</span>
              <span class="field-value">{{ userProfile?.address?.country || '-' }}</span>
            </div>
          </div>
        </div>

        @if(isAuthenticated){
        <div class="separator"></div>

        <div class="preview-section">
          <h3 class="section-title">{{ 'profile.personal.educationLevelTitle' | transloco }}</h3>
          <div class="section-content">
            <div class="preview-field">
              <span class="field-label">{{ 'profile.personal.educationLevel' | transloco }}</span>
              <span class="field-value">{{ getEducationLevelDisplay() || '-' }}</span>
            </div>
          </div>
        </div>

        <div class="separator"></div>

        <div class="preview-section">
          <h3 class="section-title">{{ 'profile.personal.jobPreferences' | transloco }}</h3>
          <div class="section-content">
            <div class="preview-field">
              <span class="field-label">{{ 'profile.personal.jobType' | transloco }}</span>
              <span class="field-value">{{ getJobTypeDisplay() || '-' }}</span>
            </div>
            <div class="preview-field">
              <span class="field-label">{{ 'profile.personal.jobCategory' | transloco }}</span>
              <span class="field-value">{{ getJobCategoryDisplay() || '-' }}</span>
            </div>
            <div class="preview-field">
              <span class="field-label">{{ 'profile.personal.jobPosition' | transloco }}</span>
              <span class="field-value">{{ getJobPositionDisplay() || '-' }}</span>
            </div>
            <div class="preview-field">
              <span class="field-label">{{ 'profile.personal.selfDescription' | transloco }}</span>
              <span class="field-value">{{ getSelfDescriptionDisplay() || '-' }}</span>
            </div>
          </div>
        </div>
        }

        <div class="separator"></div>

        <div class="preview-section">
          <h3 class="section-title">{{ 'profile.personal.aiConsents.title' | transloco }}</h3>
          <div class="ai-consent-status-grid">
            <div class="ai-consent-status-card" [class.ai-consent-status-card--enabled]="userProfile?.aiMatching">
              <div class="ai-consent-status-card__icon">
                <i class="fas fa-robot"></i>
              </div>
              <div class="ai-consent-status-card__content">
                <div class="ai-consent-status-card__header">
                  <h4>{{ ConsentType.AI_MATCHING | transloco }}</h4>
                  <span class="consent-status" [class.consent-status--enabled]="userProfile?.aiMatching">
                    {{ (userProfile?.aiMatching ? 'profile.personal.aiConsents.statusEnabled' : 'profile.personal.aiConsents.statusDisabled') | transloco }}
                  </span>
                </div>
                <p>{{ ('descriptions.' + ConsentType.AI_MATCHING) | transloco }}</p>
              </div>
            </div>

            <div class="ai-consent-status-card" [class.ai-consent-status-card--enabled]="userProfile?.aiParsing">
              <div class="ai-consent-status-card__icon">
                <i class="fas fa-file-alt"></i>
              </div>
              <div class="ai-consent-status-card__content">
                <div class="ai-consent-status-card__header">
                  <h4>{{ ConsentType.AI_PARSING | transloco }}</h4>
                  <span class="consent-status" [class.consent-status--enabled]="userProfile?.aiParsing">
                    {{ (userProfile?.aiParsing ? 'profile.personal.aiConsents.statusEnabled' : 'profile.personal.aiConsents.statusDisabled') | transloco }}
                  </span>
                </div>
                <p>{{ ('descriptions.' + ConsentType.AI_PARSING) | transloco }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="no-data" *ngIf="!userProfile && !isLoading">
        <p>{{ 'profile.noData' | transloco }}</p>
      </div>
    </div>
  </app-card>
</div>
